import React, { useEffect, useRef } from "react";
import MEL3 from "../assets/MEL.3.jpg";
import MEL1 from "../assets/MEL.1.jpg";
import wheatfield from "../assets/wheatfield.mp4";
import Plant from "../assets/plant-home.jpg";
import "./home-sections.css";

const Home = () => {
  const VideoWheat = () => {
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
      if (videoRef.current) {
        videoRef.current.playbackRate = 0.4;
      }
    }, []);

    return (
      <video ref={videoRef} autoPlay muted loop>
        <source src={wheatfield} type="video/mp4" />
      </video>
    );
  };

  return (
    <div className="home-container">
      <section className="hero-hero-section">
        <div className="hero-image-wrapper">
          <img src={MEL3} alt="Marie-Eve Leclerc" className="hero-image" />
          <div className="hero-overlay">
            <h1 style={{ color: "#c9dfc7", fontSize: 50 }}>
              Dr. Marie-Eve Leclerc, C. Psych.
            </h1>
            <h2 style={{ color: "#c9dfc7" }}>
              Therapy, Assessment and Consultation
            </h2>
            <br />
            <a className="button" href="/contact">
              Get in Touch
            </a>
          </div>
        </div>
      </section>

      <section className="home-section card fade-in">
        <div
          className="text-content"
          style={{
            width: "80%",
            backgroundColor: "white",
            borderRadius: "1.5rem",
          }}
        >
          <h3>
            All services are offered exclusively virtually, giving you the
            freedom to prioritize your mental health from the comfort and
            privacy of your own space. Access care that fits into your life—no
            commute, no waiting rooms, just meaningful support wherever you feel
            most at ease.
          </h3>
        </div>
      </section>

      <section className="home-section card fade-in">
        <div className="section-wrapper">
          <div className="video-container">
            <VideoWheat />
          </div>
          <div className="text-content">
            <h2>Services Offered</h2>
            <h3>(Adults only)</h3>
            <br />
            <ul className="styled-list">
              <li>Individual Therapy</li>
              <li>Couple Therapy</li>
              <li>
                Dialectical Behavioural Therapy and the treatment of Borderline
                Personality Disorder
              </li>
              <li>Psychodiagnostic assessments</li>
              <li>
                Assessments of attention-deficit/hyperactivity disorder (ADHD)
              </li>
              <li>Consultation services for service providers</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="home-section card fade-in">
        <div className="section-wrapper wide padded reverse">
          <div className="text-content">
            <h2>Therapeutic Models I Draw From</h2>
            <p>
              Depending on your needs, I integrate several therapeutic
              approaches, including:
            </p>
            <ul className="styled-list">
              <li>Emotion-Focused Therapy for couples and individuals (EFT)</li>
              <li>Dialectical Behaviour Therapy (DBT)</li>
              <li>Cognitive Behavioural Therapy (CBT)</li>
              <li>Developmental Couple Therapy for Complex Trauma (DCTCT)</li>
              <li>Mindfulness-Based Practices</li>
              <li>Acceptance and Commitment Therapy (ACT)</li>
              <li>Parts work</li>
            </ul>
          </div>
          <div className="image-container">
            <img src={MEL1} className="section-image" />
          </div>
        </div>
      </section>

      <section className="home-section card fade-in">
        <div className="section-wrapper wide padded">
          <div className="section-image-container left">
            <img src={Plant} className="section-image" />
          </div>
          <div className="text-content">
            <h2>What You Can Expect</h2>
            <p>
              At the heart of my work is a commitment to creating a safe,
              respectful, and collaborative space where your concerns are met
              with compassion and curiosity.
            </p>
            <p>
              You don't have to navigate things alone. If you feel that we might
              be a good fit, I invite you to explore the rest of the site or
              reach out to connect.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
